import { useEffect, useState } from "react";
import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { formatDate } from "../../shared/utils/dateFormat";
import { Loader } from "../../shared/components/loader";
import "./style.css";
import { useParams } from "react-router-dom";
import { Slide } from "react-awesome-reveal";

export const LibraryView = () => {
  const [loading, setLoading] = useState(false);
  const [libraryDatas, setLibraryDatas] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    getDatas();
  }, []);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.get("student/getReadTogetherById/" + id);
      if (response?.data?.status) {
        setLibraryDatas(response?.data?.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading={"My Library"} />
        </Slide>
      </div>
      {/* <Loader isLoading={loading} /> */}
      <div className="container">
        <div className="preview-container">
          {loading ? (
            <Loader isLoading={loading} />
          ) : (
            <>
              <div className="document-header">
                <div className="row">
                  <div className="col-md-9">
                    <h1 className="document-title">{libraryDatas?.title}</h1>
                  </div>
                  <div className="col-md-3">
                    <a
                      href={libraryDatas?.pdf_link_path}
                      target="_blank"
                      className="btn btn-primary create-btn"
                    >
                      <i className="bi bi-download"></i>&nbsp; Download
                    </a>
                  </div>
                </div>

                <div className="document-meta">
                  <div className="meta-item">
                    <i className="far fa-calendar" />
                    <span>
                      Released: {formatDate(libraryDatas?.created_at)}
                    </span>
                  </div>
                </div>
                {/* <p
                  className="document-description"
                  dangerouslySetInnerHTML={{
                    __html: libraryDatas?.short_description,
                  }}
                ></p> */}
              </div>
              <div className="pdf-preview">
                <div className="pdf-content">
                  <object
                    data={libraryDatas?.pdf_link_path}
                    type="application/pdf"
                    width="100%"
                    height={window.innerWidth <= 768 ? "400px" : "600px"}
                    style={{
                      maxWidth: "100%",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch"
                    }}
                  >
                    <p>PDF cannot be displayed. <a href={libraryDatas?.pdf_link_path}>Download PDF</a></p>
                  </object>
                  {/* <PdfViewer pdfUrl="http://localhost:8000/storage/uploads/read_together/1739373041_25._June_2022%20%20BCS-054%20IGNOUAssignmentGuru.com.pdf" /> */}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
